import React, {useContext} from 'react';
import moment from 'moment-timezone';
import {makeStyles} from '@material-ui/core/styles';
import {Grid, Typography} from '@material-ui/core';
import AfficheImage from '../Shared/AfficheImage';
import PayButton from 'components/Seances/PayButton';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import Context from 'utils/Context';
import {useTimezone} from 'hooks';

SwiperCore.use([Navigation]);

const useStyles = makeStyles(theme => ({
  wrapper: {
    textTransform: 'none',
  },
  profilInfo: {
    marginLeft: 10,
    marginRight: 24,
  },
  white: {
    color: 'white',
    textTransform: 'none',
  },
  grey: {
    color: 'grey',
  },
}));

const Rencontre = ({seance, intervenants, onPay}) => {
  const {appState} = useContext(Context);
  const classes = useStyles();

  const {displayTimezone, localTimezone} = useTimezone(seance.zone_name);

  const startTime = moment(seance.tzStartTime).tz(displayTimezone);

  const intervenantsListId = seance.intervenants ? seance.intervenants.split(',') : [];
  const profiles = intervenantsListId.reduce(function (result, item) {
    let c = intervenants.filter(el => el.id === parseFloat(item));
    result.push(c[0]);
    return result;
  }, []);

  const renderCard = profile => {
    return (
      <Grid container>
        <Grid item xs={5}>
          <AfficheImage affiche={profile.photo} alt={`${profile.nom} speaker`} />
          <div className="spacer" />
        </Grid>
        <Grid item xs={7}>
          <div className={classes.profilInfo}>
            <Typography variant="subtitle1" className={classes.white}>
              Avec
            </Typography>
            <Typography variant="body1" className={classes.white}>
              {profile.nom}
            </Typography>
            <Typography variant="body2" className={classes.grey}>
              {profile.qualite}
            </Typography>
          </div>
        </Grid>
      </Grid>
    );
  };

  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.white}>
        {startTime.format('LL')}&nbsp;
        <span style={{color: 'grey'}}>
          {startTime.format('LT')}
          {displayTimezone !== localTimezone && <sup>*</sup>}
        </span>
      </Typography>
      <PayButton onPay={onPay} showAccess seance={seance} />
      <div className="spacer" />
      <Swiper
        spaceBetween={5}
        slidesPerView={appState.screenSize === 'lg' ? 3 : 2}
        longSwipesRatio={0.2}
        autoplay
        loop={profiles.length > 2}
      >
        {profiles && profiles.map((profile, index) => <SwiperSlide key={index}>{renderCard(profile)}</SwiperSlide>)}
      </Swiper>
    </div>
  );
};

export default Rencontre;
